{"rating":"4.9","reviewCount":"141","fetchedAt":"2026-10-26T22:36:19.555Z","source":"place-details"}